import React from 'react';
import { useMarketplace } from './MarketplaceContext';
export function MarketplaceFeature({ children, marketplaces, fallback = null }) {
    const { marketplace } = useMarketplace();
    if (marketplaces.includes(marketplace)) {
        return React.createElement(React.Fragment, null, children);
    }
    return React.createElement(React.Fragment, null, fallback);
}
